import { store } from '../animation/store';
import animate from '../animation/animate';

let enterAnimateList = [];
let isPlaying = false;

const push = (data) => {
  if (!data) {
    return;
  }

  if (!MM.fixedbar.tool.getSwitch('enterAnimation')) {
    return;
  }

  if (isPlaying) {
    return;
  }

  enterAnimateList.push(data);

  start();
};

const start = () => {
  if (enterAnimateList.length === 0) {
    return;
  }

  let data = enterAnimateList.shift();
  let { decorator = {} } = data;

  if (decorator.car) {
    const allDecorators = window['MM_DECORATOR'] || [];
    const car = allDecorators.find((item) => decorator.car == item._id);
    let text = '欢迎' + '  ';
    if (data.nick_name.length > 8) {
      text = text + data.nick_name.slice(0, 7) + '...';
    } else {
      text = text + data.nick_name;
    }

    const enterData = {
      url: car.carGif,
      configUrl: car.carJson,
      imgUser: data.pic,
      imgAnchor: '',
      textUser: text,
      textAnchor: '',
      fontStyle: JSON.stringify({ color: '#FFFFFF', font: '26px PingFang' }),
    };
    //animatePosition:   0 默认（左下角），1：全屏模式
    // 全屏的播放 走礼物模式
    if (car.animatePosition === 1) {
      animate.push({
        enter: enterData,
      });
    } else {
      isPlaying = true;
      store.setEnterAnimation(enterData);
    }
  }
};

const next = () => {
  isPlaying = false;
  start();
};

const test = () => {
  push({
    decorator: { car: 3002 },
    nick_name: '昵称昵称昵昵称昵称昵称称',
    pic: 'https://test-img.sumeme.com/23/7/1516764526295.jpg',
  });
};

export default {
  push,
  next,
  test,
};
